"use client";

import NextError from "next/error";

export default function AppErrorFallback({
	error,
}: {
	error: Error & { digest?: string };
}) {
	return (
		<NextError
			statusCode={500}
			title={error.message}
		/>
	);
}
